import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class LoadingComponent {
    constructor() {
        this.size = 'medium';
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: LoadingComponent, selector: "fgbcl-loading", inputs: { size: "size" }, ngImport: i0, template: "<div class=\"text-center\">\r\n  <div class=\"spinner-border\" [ngClass]=\"{ 'spinner-border-sm': size === 'small' }\" role=\"status\">\r\n    <span class=\"visually-hidden\">Loading</span>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-loading', template: "<div class=\"text-center\">\r\n  <div class=\"spinner-border\" [ngClass]=\"{ 'spinner-border-sm': size === 'small' }\" role=\"status\">\r\n    <span class=\"visually-hidden\">Loading</span>\r\n  </div>\r\n</div>\r\n" }]
        }], propDecorators: { size: [{
                type: Input
            }] } });

class LoadingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: LoadingModule, declarations: [LoadingComponent], imports: [CommonModule], exports: [LoadingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoadingModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoadingComponent],
                    imports: [CommonModule],
                    exports: [LoadingComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingComponent, LoadingModule };
